import React, { useState } from 'react'

// redux
import { connect } from 'react-redux'

// formik
import {
    useFormik, //hook for functonal components
} from 'formik'

// yup
import * as Yup from 'yup'

// react toastify
import { toast } from 'react-toastify';


// form fields
import AppFormikInput from 'utlis/helpers/forms/AppFormikInput'

// API
import { addDomainApi } from 'utlis/Apis/Notifications_API';

// messages
import {
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE__NAME,
    DOMAIN_ADDED_SUCCESSFULLY
} from 'utlis/AppMessages/AppMessages'

// react bootstrap
import { Spinner } from 'react-bootstrap';


function EditMode(props) {
    // props
    const {
        authState,
        notificationsData,
        setNotificationsData,

        setEditModeVisibility,
        setDNSsettingsVisibility,
    } = props

    // states
    const [btnLoading, setBtnLoading] = useState(false)
    const [btnDisabled, setBtnDisabled] = useState(false)

    // initial form values
    const initialFormValues = {
        domain: notificationsData?.postmark_domain ?? "",
    }

    // handle form validations
    const formValidationSchema = Yup.object({
        domain: Yup.string()
            .required("This field is required")
            .matches(/^[a-z\-]+\.[a-z]+$/, 'Please enter a valid domain name with (yourdomain.com) format'),
    })

    // handle form submmision
    const onFormSubmit = values => {
        if (values) {
            // btn loading
            setBtnLoading(true)
            setBtnDisabled(true)

            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            // network request
            addDomainApi(headers, values.domain).then(res => {
                // btn loading
                setBtnLoading(false)
                setBtnDisabled(false)

                const resData = res.data

                // if request succesfull
                if (resData && resData.success) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.success(DOMAIN_ADDED_SUCCESSFULLY, {
                        autoClose: 2500,
                    })

                    setEditModeVisibility(false) // closing the edit mode
                    setDNSsettingsVisibility(true) // opening dns settings page

                    setNotificationsData(resData.data) // setting notifications data
                }

                // if request is not succesfull
                if (resData && resData.error) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(resData?.message ?? UNKNOWN_ERROR_OCCURED, {
                        autoClose: 2500
                    })
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} getEmails `, err.message)

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // btn loading
                        setBtnLoading(false)
                        setBtnDisabled(false)
                    }
                })
            })
        }
    }

    // formik hook
    const formik = useFormik({
        initialValues: initialFormValues,
        validationSchema: formValidationSchema,
        onSubmit: onFormSubmit,
    })

    return (
        <div className="page-border-box2 mb-3 mb-md-4 domain-info">
            <div className="pbb2-inner">
                {/* text-sec */}
                <div className="text-sec media-body pe-3">
                    <div className="app-header-wrapper heading-sm mb-2">
                        <p className="app-heading st-fw-600 text-capitalize mb-2">Add a Domain</p>
                        <p className="app-desc st-fs-14">
                            Add a domain you would like to send emails from. <br />
                            you must have access to this domain's DNS in order to verify it.
                        </p>
                    </div>
                </div>

                {/* form content */}
                <div className="form col-12 col-lg-5">
                    <form
                        onSubmit={formik.handleSubmit}
                        noValidate
                        autoComplete="off">
                        {/* form field */}
                        <AppFormikInput
                            formik={formik} // formik object
                            stFormClass={"form-sm"} // class name for main wrapper
                            labelName={"Domain"} // label name
                            isRequired={true} // is this field is required or not to show the red star sign
                            placeholder={"yourdomain.com"} // placeholder for the input
                            formikFieldName={"domain"} // important: formik value name for the input
                        />

                        <div className="btns d-flex pt-2">
                            <button
                                type="submit"
                                className={`st-btn st-btn-primary st-btn-sm me-2 ${btnDisabled ? "disabled" : ""}`}
                                disabled={btnDisabled}>
                                {
                                    btnLoading ? (
                                        <Spinner size="sm" animation="border" />
                                    ) : (
                                        "Save"
                                    )
                                }
                            </button>
                            <button className="st-btn st-btn-link st-btn-sm no-min-width" onClick={ev => {
                                ev.preventDefault()

                                setEditModeVisibility(false) // enabling edit mode
                            }}>
                                Cancel
                            </button>
                        </div>

                    </form>
                </div>

            </div>
        </div>
    )
}


const getDataFromStore = state => {
    return {
        authState: state.auth,
    };
}

const dispatchActionsToProps = dispatch => {
    return {
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(EditMode)